export const TRUCK_ID = "truckId";
